import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['dependent', 'trigger']

  static values = {
    match: String,
  }

  connect() {
    this.update()
  }

  update() {
    const enabled = this.selectedValue === this.matchValue

    this.dependentTargets.forEach((element) => {
      element.disabled = !enabled
    })
  }

  get selectedValue() {
    return this.triggerTargets.find((trigger) => trigger.checked)?.value
  }
}
